/* eslint-disable @typescript-eslint/no-explicit-any */
import {Modal, Typography, Table} from 'antd';
import React from 'react';

import {drawerZIndex} from '../../../constants/Common';

const {Text} = Typography;

export const ESGFrameworkDetail: React.FC<{
  companyName: string;
  headerTitle: string;
  contentDetail: string;
  open: boolean;
  onClose: () => void;
}> = ({companyName, headerTitle, contentDetail, open, onClose}) => {
  return (
    <Modal
      title={headerTitle}
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={'50%'}
      zIndex={drawerZIndex}
      className="esgFrameworkBenchmarking"
    >
      <div
        style={{
          marginTop: 20,
          padding: '20px 20px 45px 20px',
          backgroundColor: '#f3f4f8',
          borderTop: 'solid 1px #dee0e4',
          borderBottom: 'solid 1px #dee0e4'
        }}
      >
        <Text strong>{companyName}</Text>
        <br />
        <div style={{marginTop: '10px'}}>
          <Text style={{fontSize: 14}}>{contentDetail}</Text>
        </div>
      </div>
    </Modal>
  );
};

export const PeerAveragePopup: React.FC<{
  contentDetail: string;
  open: boolean;
  onClose: () => void;
}> = ({contentDetail, open, onClose}) => {
  return (
    <Modal
      title={'Peer Average'}
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={'50%'}
      zIndex={drawerZIndex}
      className="esgFrameworkBenchmarking"
    >
      <div
        style={{
          marginTop: 20,
          padding: '20px 20px 45px 20px',
          backgroundColor: '#f3f4f8',
          borderTop: 'solid 1px #dee0e4',
          borderBottom: 'solid 1px #dee0e4'
        }}
      >
        <br />
        <div style={{marginTop: '10px'}}>
          <Text style={{fontSize: 14}}>{contentDetail}</Text>
        </div>
      </div>
    </Modal>
  );
};

const getSourceInfoColumns = (selectedYear: string) => {
  const columns: any[] = [
    {
      title: 'Company',
      dataIndex: 'company',
      key: 'company',
      render: (text: string) => <Text strong>{text}</Text>
    },
    {
      title: 'Company Website',
      dataIndex: 'website',
      key: 'website',
      render: (text: string, record: any) => <a href={record.websiteLink} target="_blank" rel="noreferrer">{text}</a>
    }
  ];

  const col23 = {
    title: 'Public-domain reports/sources - FY 2023-24',
    dataIndex: 'report23',
    key: 'report23',
    render: (text: string, record: any) =>
      text.includes('N/A') ? (
        <Text strong>{text}</Text>
      ) : (
        <a href={record.report23Link || '#'} target="_blank" rel="noreferrer">
          {text}
        </a>
      )
  };

  const col24 = {
    title: 'Public-domain reports/sources - FY 2024-25',
    dataIndex: 'report24',
    key: 'report24',
    render: (text: string, record: any) =>
      text.includes('N/A') ? (
        <Text strong>{text}</Text>
      ) : (
        <a href={record.report24Link || '#'} target="_blank" rel="noreferrer">
          {text}
        </a>
      )
  };

  if (selectedYear === '2023-2024' || selectedYear === '2023-24') {
    columns.push(col23);
  } else if (selectedYear === '2024-2025' || selectedYear === '2024-25') {
    columns.push(col24);
  } else {
    columns.push(col23);
    columns.push(col24);
  }

  return columns;
};

const SOURCE_INFO_DATA = [
  {
    key: '1',
    company: 'Allcargo Logistics Ltd.',
    website: 'Allcargo Logistics',
    websiteLink: 'https://www.allcargologistics.com',
    report23: 'BRSR / Business Sustainable & Responsible Report 2023-24',
    report23Link:
      'https://www.allcargologistics.com/investor/logistics-annual-reports',
    report24: 'BRSR 2024-25',
    report24Link:
      'https://www.allcargologistics.com/investor/logistics-annual-reports'
  },
  {
    key: '2',
    company: 'Mahindra Logistics Ltd.',
    website: 'Mahindra Logistics',
    websiteLink: 'https://mahindralogistics.com',
    report23: 'ESG Impact Book 2023-24 / BRSR 2023-24',
    report23Link: 'https://mahindralogistics.com/',
    report24: 'ESG Impact Book 2024-25 / BRSR 2024-25',
    report24Link:
      'https://mahindralogistics.com/wp-content/uploads/2025/10/ESG-Impact-Book-25.pdf'
  },
  {
    key: '3',
    company: 'Aegis Logistics Ltd.',
    website: 'Aegis Logistics',
    websiteLink: 'https://www.aegisindia.com',
    report23: 'Annual Report 2023-24 – includes BRSR',
    report23Link:
      // eslint-disable-next-line max-len
      'https://aegisindia.com/wp-content/uploads/2024/06/Aegis-Logistics-Final-Cover-to-Cover-Interactive.pdf',
    report24: 'Annual Report 2024-25 – includes BRSR',
    report24Link:
      'https://aegisindia.com/wp-content/uploads/2025/07/Aegis-AR-2024-25_C2C_Final.pdf'
  },
  {
    key: '4',
    company: 'Zinka Logistics Solutions Ltd. (BlackBuck)',
    website: 'BlackBuck',
    websiteLink: 'https://www.blackbuck.com',
    report23: 'N/A - no BRSR for FY 2023-24',
    // report23Link: '',
    report24: 'Annual Report / BRSR 2024-25',
    report24Link:
      // eslint-disable-next-line max-len
      'https://bb-website-public-assets.s3.ap-south-1.amazonaws.com/legal-assets/pdf/Annual+Reports/Annual+Report+FY+2024-25.pdf'
  },
  {
    key: '5',
    company: 'TCI Express Ltd.',
    website: 'TCI Express',
    websiteLink: 'https://www.tciexpress.in',
    report23: 'BRSR - Annual Report 2023-24',
    report23Link:
      'https://tciexpress.in/images/pdf/1192_AnnualReportFY2024.pdf',
    report24: 'BRSR - Annual Report 2024-25',
    report24Link:
      'https://www.tciexpress.in/images/pdf/1250_Annual%20Report_TCI%20Express_2024-25.pdf'
  }
];

export const PeerSourceInfoPopup: React.FC<{
  open: boolean;
  onClose: () => void;
  selectedYear?: string;
}> = ({open, onClose, selectedYear = ''}) => {
  return (
    <Modal
      title="Source of Information"
      open={open}
      onCancel={onClose}
      footer={null}
      centered
      width={'70%'}
      zIndex={drawerZIndex}
      className="esgFrameworkBenchmarking"
    >
      <div
        style={{
          marginTop: 20,
          padding: '20px 20px 45px 20px',
          backgroundColor: '#f3f4f8',
          borderTop: 'solid 1px #dee0e4',
          borderBottom: 'solid 1px #dee0e4'
        }}
      >
        <Table
          columns={getSourceInfoColumns(selectedYear)}
          dataSource={SOURCE_INFO_DATA}
          pagination={false}
          bordered
          size="small"
        />
      </div>
    </Modal>
  );
};
